
import Banner from "../components/banner/Banner";
import Footer from "../components/footer/Footer";
import Navbar from "../components/navbar/Navbar";
import "../components/cart/Cart.css"
import AdminLoginPage from "../components/login/AdminLoginComp";
import { useEffect } from "react";

const AdminLogin=()=>{
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return(
        <div className="bg-imagea">
<Navbar/>
 <Banner title="Login"/>
<AdminLoginPage/>
<Footer/>
</div>
    )
}
export default AdminLogin;